import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem, Button } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo'

import students1 from '../../assets/students1.jpg'
import students2 from '../../assets/students2.jpg'
import students3 from '../../assets/students3.jpg'
import students4 from '../../assets/students4.jpg'
import ads1 from '../../assets/ads1.png'
import ads2 from '../../assets/ads2.png'
import ads3 from '../../assets/ads3.png'
import ads4 from '../../assets/ads4.png'

import { Link } from 'react-router-dom'
import apple from '../../assets/apple.svg'
import google from '../../assets/google.svg'

export const Sponsors = ({ }) => {
  const Navigate = useNavigate()

  const theme = useTheme()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Stack sx={{ width: '100vw', minHeight: '100vh' }} alignItems={'center'}>
      <Stack
        sx={{ width: '100vw', height: 200 }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Logo width={200} />
      </Stack>

      <Stack
        direction={'column'}
        sx={{ maxWidth: 600, justifyContent: 'center' }}
        style={{ fontSize: 22, marginBottom: 16 }}
      >
        <motion.div style={{ fontSize: 16, fontWeight: 300, marginBottom: 20 }}>
        Advertise on JoinU – Support Community Engagement at Harvard
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
        JoinU is a socially responsible platform for the entire community, managed by students and supported by the Public Interest Tech Lab at Harvard. 
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 10, marginTop: 30  }}>
        Connect Your Brand with Harvard's Community!
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={students1}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5, marginTop: 10 }}>
        Join us in fostering a vibrant campus community! We build community by bringing people together to share experiences and activities. With thousands of user sponsored events, we connect.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 10, marginTop: 30 }}>
        Why Advertise with Us?
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={students2}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 10 }}>
        Community Impact: Your advertisement on JoinU not only reaches a wide audience but also supports socially responsible initiatives designed to enhance campus life. Be part of a movement that values engagement!
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={students3}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 10 }}>
        Visibility: With thousands of events and hundreds of daily views, your ad will gain significant exposure among students, faculty, and staff in the Harvard community, both in the app and through our weekly newsletter.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 10, marginTop: 30 }}>
        Advertisement Features
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={ads1}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 10 }}>
        Clicking on an ad listing provides detailed information about your store and offer, similar to how clicking on an event listing displays details about that event.
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={ads2}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 20 }}>
        Flexible Advertising Options: Choose how you want to present your brand. Display your store name alone, add a special discount to attract more students, or contribute a lottery item to our weekly give-a-ways to create excitement and draw.
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={ads3}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 20 }}>
        Members of JoinU can present your ad copy in-store to avail discounts. Since a HarvardKey login is required to access the app, you can confidently verify that the individual is a JoinU member and part of the Harvard community.
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={ads4}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 10 }}>
        Donated items are featured in JoinU's weekly giveaways. JoinU members simply click on your ad to enter your lottery event. Past giveaways have included tablets, gift cards, and food drops, showcasing a variety of attractive prizes for our community. You provide the prize, and we handle the entire lottery process directly through the app.
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        When a member clicks "Join" on your advertisement, your store's information is seamlessly integrated into their personal calendar as an event by default.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 10 }}>
        Call to Action!
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={students4}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30, marginTop: 10 }}>
        Are you ready to make a difference and connect with the leaders of tomorrow? Contact us today to set up your advertisement on JoinU. Let’s work together to keep Harvard vibrant and connected!
        </motion.div>
        <List
          sx={{
            listStyleType: 'decimal',
            pl: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
              pt: 0,
              pb: 0,
              pr: 0,
            },
          }}
        >
         {[
            'Bronze Package: $50 donation includes a basic ad placement ensuring over a thousand views.',
            'Silver Package: $100 donation includes enhanced placement and a feature in our weekly newsletter.',
            'Gold Package: $200 donation includes premium ad placement, newsletter feature, and increased visibility among events.',
          ].map((d, i) => (
            <ListItem style={{ fontSize: 18, marginBottom: 5 }}>{d}</ListItem>
          ))}
        </List>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 30, marginTop: 30 }}>
        <a href='https://myprivacypolls.org/survey/b/uxchwcsa-txodcazganpglqfz' target='_blank' rel='noreferrer'>
        Sign Up Now <p>&nbsp;</p>Click here to access our secure form and get started
          </a>
        </motion.div>
      </Stack>
    </Stack>
  )
}
